<div id="about-us">
    <div id="showcase">
        <img src="/assets/img//showcase/11.jpeg" alt="banner" class="img-fluid w-100">
    </div>
    <div id="heading">
        <h1>Job Application Form</h1>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
              <li class="breadcrumb-item active" aria-current="page">Job Application Form</li>
            </ol>
          </nav>
    </div>
    <!-- <div class="alert alert-info mx-5 my-2 my-lg-5" role="alert">
        You have missed the deadline..!!
      </div> -->
    <div>
        <iframe frameborder="0" style="height:2900px;width:99%;border:none;" src='https://forms.zohopublic.in/odforms1/form/GURUNANAKKHALSACOLLEGE/formperma/TsoebWPhxsUr99HUTu0rhzy2IB5Z2z5koG8SfP64aW4'></iframe>
    </div>
</div>